<template>
    <div class="process-data-link-config">
        <el-row>
            <el-col :span="12" >
                <div class="process-data-link-config-sourceMethod">
                    <el-form size="mini" ref="sourceMethodForms">
                        <el-form-item label="数据源">
                            <el-select v-model="sourceMethod" placeholder="请选择数据源" class="triggerSource" @change="changeSourceMethod">
                                <el-option
                                    v-for="item in sourceMethods"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
            </el-col>
            <el-col :span="6" >
              <div class="process-data-link-config-opera">
                <el-select v-model="processState" placeholder="请选择流程状态" class="triggerSource">
                    <el-option
                        v-for="item in processStateArr"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6" >
                <div class="process-data-link-config-opera">
                    <el-button type="primary" @click="addLinkData">新增映射关系</el-button>
                </div>
            </el-col>
        </el-row>
        <div class="process-data-link-config-body">
            <div class="process-data-link-config-body-item" v-for="(obj,index) in linkData" :key="index">
                <div class="opear-delete"><i class="el-icon-delete" @click="deleteLinkData(obj)"></i></div>
                <div class="process-data-link-config-body-item-top">
                    <div class="target-field">
                       <div class="lable">映射关系</div>
                       <div class="content">
                            <div class="target-form-field">
                                <el-select v-model="obj.sourceFieldId" placeholder="请选择源数据字段" class="triggerSource" @change="changeSourceField(obj)">
                                    <el-option
                                        v-for="item in sourceOptions"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                       </div>
                    </div>
                    <div class="target-config">
                       <div class="lable">目标字段</div>
                       <div class="content">
                            <div class="target-form-field">
                              <el-select v-model="obj.targetFieldId" clearable placeholder="请选择目标表单的字段" @change="changeTargetField(obj)">
                                  <el-option
                                    v-for="item in targetOptions"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                  </el-option>
                              </el-select>
                            </div>
                       </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="process-data-link-config-opera">
            <el-button type="info" @click="cancelClick">取消</el-button> 
            <el-button :loading="loading" type="primary" @click="confirmClick">确定</el-button> 
        </div>
    </div>
</template>

<script>
    import { getCustomFormDataMapingListByFormId, saveCustomFormDataMapings, getFormConfig } from '@/data-model';
    import { processFieldList, approvalFieldList, taskFieldList, departmentFieldList } from './default-data';
    export default{
        data () {
            return {
                sourceMethod: 'processInfo',
                sourceMethods: [
                    {
                        id: 'processInfo',
                        name: '流程数据'
                    }, {
                        id: 'processTaskInfo',
                        name: '任务数据'
                    }, {
                        id: 'approvalInfo',
                        name: '审批流数据'
                    }, {
                        id: 'departmentInfo',
                        name: '部门数据'
                    }
                ],
                processState: 0,
                processStateArr: [
                    {
                        id: 0,
                        name: '全部'
                    }, {
                        id: 1,
                        name: '进行中'
                    }, {
                        id: 2,
                        name: '已完成'
                    }
                ],
                loading: false,
                sourceOptions: processFieldList,
                targetOptions: [],
                linkData: [
                    {
                        key: this.generateUUID(),
                        sourceField: '',
                        targetField: '',
                        targetFormId: this.formId,
                        targetModelId: this.modelId
                    }
                ]
            };
        },
        props: {
            formId: {
                type: String
            },
            modelId: {
                type: String,
                default: ''
            }
        },
        created () {
            this.initPage();
        },
        methods: {
            async initPage (obj) {
                this.getFormDetail();
                this.getCustomFormDataMapingListByFormId();
            },
            changeSourceMethod () {
                if (this.sourceMethod === 'processInfo') {
                    this.sourceOptions = processFieldList;
                } else if (this.sourceMethod === 'processTaskInfo') {
                    this.sourceOptions = taskFieldList;
                } else if (this.sourceMethod === 'approvalInfo') {
                    this.sourceOptions = approvalFieldList;
                } else if (this.sourceMethod === 'departmentInfo') {
                    this.sourceOptions = departmentFieldList;
                }
            },
            async getFormDetail () {
                if (this.formId) {
                    const { fieldsList } = await getFormConfig(this.formId);
                    this.targetOptions = fieldsList;
                }
            },
            async getCustomFormDataMapingListByFormId () {
                if (this.formId) {
                    let param = {
                        formId: this.formId
                    };
                    let data = await getCustomFormDataMapingListByFormId(param);
                    if (data && data.mapingBOList && data.mapingBOList.length > 0) {
                        this.linkData = data.mapingBOList;
                        this.sourceMethod = data.mapingBOList[0].sourceMethod;
                        this.processState = data.mapingBOList[0].processState;
                        this.changeSourceMethod();
                    }
                    // console.log(this.linkData);
                }
            },
            addLinkData () {
                let item = {
                    key: this.generateUUID(),
                    sourceField: '',
                    targetField: '',
                    targetFormId: this.formId,
                    targetModelId: this.modelId,
                    processState: this.processState
                };
                this.linkData.unshift(item); // list头部新增
            },
            deleteLinkData (e) {
                for (let i = 0; i < this.linkData.length; i++) {
                    let cur = this.linkData[i];
                    if (cur.key === e.key) {
                        this.linkData.splice(i, 1);
                    }
                }
            },
            generateUUID () {
                var d = new Date().getTime();
                if (window.performance && typeof window.performance.now === 'function') {
                    d += window.performance.now(); // use high-precision timer if available
                }
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid.replace(RegExp('-', 'g'), '');
            },
            changeSourceField (e) {
            },
            changeTargetField (e) {
            },
            async confirmClick () {
                this.loading = true;
                let param = {
                    sourceMethod: this.sourceMethod,
                    targetModelId: this.modelId,
                    targetFormId: this.formId,
                    processState: this.processState,
                    mapingBOList: this.linkData

                };
                await saveCustomFormDataMapings(param);
                this.loading = false;
                this.$emit('confirm');
            },
            cancelClick () {
                this.$emit('cancel');
            }
        }

    };
</script>

<style lang="less">
    .process-data-link-config{
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        overflow: auto;
        .process-data-link-config-sourceMethod{
            height: 40px;
            line-height: 40px;
            text-align: left;
            padding-right: 20px;
        }
        .process-data-link-config-opera{
            height: 40px;
            line-height: 40px;
            text-align: right;
            padding-right: 10px;
        }
        .process-data-link-config-body{
            flex: 1;
            .process-data-link-config-body-item{
                display: flex;
                border: 1px solid #F2F2F2;
                flex-direction: column;
                line-height: 100px;
                width: 96%;
                margin-top: 10px;
                margin-left: 20px;
                cursor: pointer;
                .opear-delete{
                   text-align: right;
                   padding-right: 20px;
                   height: 0px;
                   z-index: 999;
                }
                .process-data-link-config-body-item-top{
                    display: flex;
                    .source-field{
                        width: 300px;
                        display: flex;
                        margin-left: 10px;
                        .lable{
                           width: 90px;
                           text-align: center;
                        }
                        .content{
                           line-height: 20px;
                           margin-top: 35px;
                        }
                    }
                    .target-field{
                        display: flex;
                        .lable{
                            width: 100px;
                            text-align: center;
                        }
                        .content{
                           line-height: 20px;
                           margin-top: 35px;
                           display: flex;
                           .target-form{
                               width: 300px;
                           }
                           .target-form-field{
                               margin-left: 10px;
                           }
                        }
                    }
                    .target-config{
                        display: flex;
                        flex: 1;
                        .lable{
                            width: 140px;
                            text-align: center;
                        }
                        .content{
                           line-height: 20px;
                           margin-top: 35px;
                           display: flex;
                           .target-form{
                               width: 200px;
                           }
                           .target-form-field{
                               margin-left: 10px;
                           }
                        }
                    }
                }
                .process-data-link-config-body-item-bottom{
                   .field-item{
                       display: flex;
                       .field-option-lable{
                           width: 90px;
                           padding-left: 20px;
                       }
                       .field-option{
                           color: red;
                       }
                       .bind-field-value{
                           width: 300px;
                           line-height: 10px;
                           margin-top: 35px;
                       }
                       .bind-field-lable{
                           width: 140px;
                           margin-left: 20px;
                       }

                   }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ProcessDataLinkConfig/ProcessDataLinkConfig.vue